import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AccessRightsService {
  constructor(private apiService: ApiService) {}
  public getRight(id: string, type: string) {}

  public getRights(type: string, entityId: string): Observable<any> {
    const url = '/' + type + '/' + entityId + '/rights';
    return this.apiService.get(url).pipe(
      map((rights: any) => {
        return rights;
      })
    );
  }

  public updateRights(type: string, entityId: string, accessRights: any): Observable<any> {
    const url = '/' + type + '/' + entityId + '/rights/post';
    return this.apiService.post(url, { accessRights: accessRights }).pipe(
      map((rights: any) => {
        return rights;
      })
    );
  }
}
